export default __webpack_public_path__ + "static/media/fr-20r.3e977cf0.svg";